import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientBaseComponent } from './patient-base.component';
import { IonicModule } from '@ionic/angular';
import { MatExpansionModule } from '@angular/material';
import { TranslateModule } from '../../../../../shared/translate/translate.module';
import { MonoAvatarModule } from '../../../../../shared/directives/mono-avatar/mono-avatar.module';
import { PatientPipesModule } from './../../../pipes/patient-pipes.module';

@NgModule({
  declarations: [PatientBaseComponent],
  imports: [
    CommonModule,
    TranslateModule,
    IonicModule,
    MatExpansionModule,
    MonoAvatarModule,
    PatientPipesModule
  ],
  exports: [
    PatientBaseComponent
  ]
})
export class PatientBaseModule { }
